import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store/index'

import '@/services/firebase/index'
import '@/registerServiceWorker'
import '@/quasar'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
